'use client';

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';
import { Download } from 'lucide-react';
import { useSyncExternalStore } from 'react';

import { PdfDownloadLink } from '@/entities/masterclass/types';

/**
 * Модалка со списком PDF, если у МК их несколько. Смонтирована один раз в AppProvider
 * (как Toaster), открывается из useDownloadMasterclassMutation через openPdfLinksModal.
 * Каждый файл качается по клику пользователя — авто-скачивание пачкой браузеры режут.
 */
const EMPTY: PdfDownloadLink[] = [];
let currentFiles: PdfDownloadLink[] = EMPTY;
const listeners = new Set<() => void>();

const setFiles = (files: PdfDownloadLink[]) => {
  currentFiles = files;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const openPdfLinksModal = (files: PdfDownloadLink[]) => setFiles(files);

export const PdfLinksModal = () => {
  const files = useSyncExternalStore(
    subscribe,
    () => currentFiles,
    () => EMPTY,
  );
  const close = () => setFiles(EMPTY);

  return (
    <Modal isOpen={files.length > 0} onClose={close} placement="center">
      <ModalContent>
        <ModalHeader>Файлы мастер-класса</ModalHeader>
        <ModalBody>
          <p className="text-small text-default-500">
            Нажмите на файл, чтобы скачать. Ссылки действуют 15 минут.
          </p>
          <div className="flex flex-col gap-2">
            {files.map((file) => (
              <Button
                key={file.url}
                as="a"
                href={file.url}
                variant="flat"
                color="primary"
                className="h-auto min-h-10 justify-start whitespace-normal py-2 text-left"
                startContent={<Download size={18} className="shrink-0" />}
              >
                {file.fileName}
              </Button>
            ))}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button variant="light" onPress={close}>
            Закрыть
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
